// Costanti condivise per le Richieste di Intervento (allineate agli OptionSet Dataverse)

export const STATO = {
  IN_ATTESA: 100000001,
  APPROVATA: 100000002,
  IN_LAVORAZIONE: 100000003,
  CONCLUSA: 100000004,
  RIFIUTATA: 100000005,
};

// label + variant Badge
export const STATO_META = {
  [STATO.IN_ATTESA]: { label: "In attesa approvazione", variant: "warning" },
  [STATO.APPROVATA]: { label: "Approvata", variant: "info" },
  [STATO.IN_LAVORAZIONE]: { label: "In lavorazione", variant: "primary" },
  [STATO.CONCLUSA]: { label: "Conclusa", variant: "success" },
  [STATO.RIFIUTATA]: { label: "Rifiutata", variant: "danger" },
};

export const TIPOLOGIA_RICHIESTA = {
  100000000: "Ordinario",
  100000001: "Straordinario",
};

export const ESITO = {
  100000000: "Positivo",
  100000001: "Negativo",
};

export const ESITO_OPTIONS = [
  { value: 100000000, label: "Positivo" },
  { value: 100000001, label: "Negativo" },
];

export function statoMeta(stato) {
  return STATO_META[stato] || { label: "—", variant: "default" };
}
